import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=723dd94e&scoped=true&"
import script from "./side-menu.vue?vue&type=script&lang=js&"
export * from "./side-menu.vue?vue&type=script&lang=js&"
import style0 from "./side-menu.vue?vue&type=style&index=0&id=723dd94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723dd94e",
  null
  
)

export default component.exports